<template>
  <div class="faq-config">
    <h3>Configuration de la FAQ</h3>

    <div class="form-group">
      <label>Activer la FAQ</label>
      <select v-model="moduleData.enabled">
        <option value="yes">Oui</option>
        <option value="no">Non</option>
      </select>
    </div>

    <div class="form-group">
      <label>Nombre de réponses max</label>
      <input type="number" v-model.number="moduleData.maxResponses" />
    </div>

    <div class="form-group">
      <label>Questions / Réponses</label>
      <div v-for="(qa, index) in moduleData.list" :key="index" class="faq-pair">
        <input v-model="qa.question" placeholder="Question" />
        <input v-model="qa.answer" placeholder="Réponse" />
        <button @click="removeFaq(index)">Supprimer</button>
      </div>
      <button @click="addFaq">+ Ajouter une Q/R</button>
    </div>

    <div class="form-group">
      <button @click="saveModule">💾 Enregistrer</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { agents } from '@/services/api' // adapte si ton chemin est différent
import { useRoute } from 'vue-router'

const route = useRoute()
const agentId = route.params.agentId
const moduleId = route.params.moduleId

const moduleData = ref({
  enabled: 'yes',
  maxResponses: 5,
  list: []
})

onMounted(async () => {
  try {
    const modules = await agents.modules.get(agentId)
    const current = modules.find(m => m.id === moduleId)
    if (current) {
      moduleData.value = {
        enabled: current.enabled || 'yes',
        maxResponses: current.maxResponses || 5,
        list: Array.isArray(current.list) ? current.list : []
      }
    }
  } catch (err) {
    console.error('Erreur chargement module FAQ:', err.message)
  }
})

function addFaq() {
  if (!Array.isArray(moduleData.value.list)) {
    moduleData.value.list = []
  }
  moduleData.value.list.push({ question: '', answer: '' })
}

function removeFaq(index) {
  moduleData.value.list.splice(index, 1)
}

async function saveModule() {
  try {
    await agents.modules.update(agentId, moduleId, moduleData.value)
    alert('Module FAQ enregistré avec succès')
  } catch (err) {
    console.error('Erreur sauvegarde:', err.message)
    alert('Erreur lors de la sauvegarde')
  }
}
</script>

<style scoped>
.faq-config {
  margin-top: 1rem;
}
.form-group {
  margin-bottom: 1rem;
}
.faq-pair {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.faq-pair input {
  flex: 1;
}
</style>
